
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace } from "vuex-class";
import LiveCameras from "@/components/mobile/live/LiveCameras.vue";
import DispatchQueueList from "@/components/mobile/dispatch/DispatchQueueList.vue";
import MobileGuardList from "@/components/mobile/dispatch-manage/GuardsList.vue";
import MobileEventQueue from "@/components/mobile/events/MobileEventQueue.vue";


const Mobile = namespace("mobile");

@Component({
	components: {
		"dispatch-request": DispatchQueueList,
		"live-cameras": LiveCameras,
		"mobile-guards-list": MobileGuardList,
		"mobile-event-queue": MobileEventQueue
	}
})
export default class RightSideBar extends Vue {
	@Mobile.Getter("getIsRightSidebarOpen") isRightSidebarOpen: boolean;
	@Mobile.Getter("getIsLeftSidebarOpen") isLeftSidebarOpen: boolean;
	@Mobile.Mutation toggleRightSidebarVisibility: any;
	@Mobile.State(state => state.RightComponentName) sideBarComponent: string;

	@Prop(Boolean)
	public openRightSidebar: boolean;

	@Watch("openRightSidebar")
	private onRightSideBarChanged() {
		this.toggleRightSidebarVisibility();
	}

	private get showRightSidebar(): boolean {
		return this.isRightSidebarOpen && !this.isLeftSidebarOpen;
	}
}
